import { createI18nText } from '@hilma/netina2all';

const orderSummaryManagementText = createI18nText({
	he: {
		title: 'הזמנות שלי',
		noPurchasesThisYear: 'אין הזמנות בשנה זו',
		phone: 'טלפון',
		paymentDate: 'תאריך הזמנה',
		station: 'תחנה',
		association: 'עמותה',
		allAssociations: 'חלוקה לכל העמותות',
		productSummary: 'סיכום מוצרים',
		amount: 'כמות',
		total: 'סה"כ',
		holders: 'נרתיקים',
		costSummary: 'סיכום עלויות',
		fourCost: 'עלות המוצרים',
		itemsCost: 'עלות המוצרים',
		fourDonation: 'תרומה מרכישת המוצרים',
		itemsDonation: 'תרומה מרכישת המוצרים',
		atoneDonation: 'תרומה ממתנות לאביונים',
		totalDonated: 'סה"כ תרומה',
		allDonated: 'הכל לתרומה',
		totalPayment: 'סה"כ לתשלום',
		cancelOrder: 'בטל הזמנה',
		stationDetails: 'פרטי תחנה',
		receipts: 'קבלות',
		downloadReceipt: 'הורד קבלה',
		downloadRefundReceipt: 'הורד קבלת החזר',
		downloadDonationReceipt: 'הורד קבלת תרומה',
		downloadRefundDonationReceipt: 'הורד קבלת החזר תרומה',
		back: 'חזור',
		sureWantToCancel: 'בטוח שברצונך לבטל את ההזמנה?',
		orderCanceled: 'הזמנה בוטלה',
		orderPickedUp: 'הזמנה נאספה',
		order: 'הזמנה'
	},
	en: {
		title: 'My orders',
		noPurchasesThisYear: 'No purchases in chosen year',
		phone: 'Phone Number',
		paymentDate: 'Order Date',
		station: 'Station',
		association: 'Association',
		allAssociations: 'All associations',
		productSummary: 'Product Summary',
		amount: 'Amount',
		total: 'Total',
		holders: 'Holders',
		costSummary: 'Cost Summary',
		fourCost: 'Cost of the products',
		itemsCost: 'Cost of the items',
		fourDonation: 'Donation from acquisition of the products',
		itemsDonation: 'Donation from acquisition of the items',
		atoneDonation: "Donation from Matanot L'evyonim",
		totalDonated: 'Donated in Total',
		allDonated: 'The full sum is donated to charity',
		totalPayment: 'Total',
		cancelOrder: 'cancel order',
		stationDetails: 'station details',
		receipts: 'Receipts',
		downloadReceipt: 'receipt',
		downloadRefundReceipt: 'refund receipt',
		downloadDonationReceipt: 'donation receipt',
		downloadRefundDonationReceipt: 'refund donation receipt',
		back: 'back',
		sureWantToCancel: 'Are you sure you want to cancel the order?',
		orderCanceled: 'order canceled',
		orderPickedUp: 'order picked up',
		order: 'order'
	}
});

export default orderSummaryManagementText;